import { defineTheme } from 'core'

export function useRecordingState() {
  const route = useRoute('listen')
  return useRecordingData(route.params.id)
}

/** Get vocal data for current scope (listen page) */
export function getData() {
  const data = useRecordingState().data.value

  if (!data)
    throw new Error('No recording data found for current scope. Make sure useRecordingData has been called')

  return data
}

export function useRecordingError() {
  const state = useRecordingState()

  return reactiveComputed(() => {
    /** Root error of async data */
    const context = state.error.value

    /** If there's any error */
    const hasError = !!context

    /** Cause of error */
    const cause = {
      invalid: context?.message.includes('Are you playing a game'),
      notFound: context?.message.includes('Does not seem to exist'),
      parsing: !!context?.stack?.includes('validation')
    }

    return { hasError, context, cause }
  })
}

export function useTheme() {
  return defineTheme({
    'color-primary-5': ['primary', 0.05],
    'color-neutral-5': ['neutral', 0.05],
    'color-elevation': ['background', 1, -0.01],

    // Player
    'player-cta-bg': ['primary'],
    'player-cta-outline': ['primary'],
    'player-cta-icon': ['background'],

    'player-bar-color': ['neutral', 0.55],
    'player-bar-fill-color': ['primary']
  }, { id: useId() })
}
